import { Tabs, rem } from '@mantine/core';
import { IconCode, IconTextCaption, IconUser, IconShoppingCart } from '@tabler/icons-react';
import { PageHeader } from '../../components/PageHeader';
import { OrganisationsView } from './components/OrganisationView';
import { StockAppAccountsView } from "./components/StockAppAccountsView";

const iconStyle = { width: rem(12), height: rem(12) };

export function BristecAdmin() {
	return (
		<Tabs defaultValue={'organisations'} w={'100%'} color={'medepos.2'}>
			<Tabs.List
				style={{
					marginBottom: 30,
				}}
			>
				<Tabs.Tab value={'settings'} leftSection={<IconCode style={iconStyle} />}>
					Settings
				</Tabs.Tab>
				<Tabs.Tab
					value={'organisations'}
					leftSection={<IconUser style={iconStyle} />}
				>
					Organisations
				</Tabs.Tab>		<Tabs.Tab
					value={'stock-accounts'}
					leftSection={<IconShoppingCart style={iconStyle} />}
				>
					Stock App Accounts
				</Tabs.Tab>
				<Tabs.Tab
					value={'logs'}
					leftSection={<IconTextCaption style={iconStyle} />}
				>
					Logs
				</Tabs.Tab>
			</Tabs.List>

			<Tabs.Panel value={'settings'}>
				<PageHeader title={'Settings'} hideFiltering />
			</Tabs.Panel>

			<Tabs.Panel value={'organisations'}>
				<OrganisationsView />
			</Tabs.Panel>

            <Tabs.Panel value={'stock-accounts'}>
                <StockAppAccountsView />
            </Tabs.Panel>

			<Tabs.Panel value={'logs'}>
				<PageHeader title={'Logs'} hideFiltering />
			</Tabs.Panel>
		</Tabs>
	);
}
